/**
 * No Logic should go in this file, please insert logic to another file
 * and load scripts here
 */
(function(window, document) {
    'use strict';

    function loadScript(url, callback) {
        /* Load script from url and calls callback once it's loaded */
        var scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'text/javascript');
        scriptTag.setAttribute('src', url);
        if (typeof callback !== 'undefined') {
            if (scriptTag.readyState) {
                /* For old versions of IE */
                scriptTag.onreadystatechange = function() {
                    if (this.readyState === 'complete' || this.readyState === 'loaded') {
                        callback();
                    }
                };
            } else {
                scriptTag.onload = callback;
            }
        }
        (document.getElementsByTagName('body')[0] || document.documentElement).appendChild(scriptTag);
    }

    function getScriptParameter(url, sParam) {
        var sPageURL = url;
        var params = url.split('?');
        if (params.length < 2) {
            return '';
        }
        var paramStr = params[1];
        var sURLVariables = paramStr.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    }

    // Get event_id
    var scriptSrc = document.getElementById('activity-stream-mini-loader').src;
    var event_id = getScriptParameter(scriptSrc, 'eid');
    var host = getScriptParameter(scriptSrc, 'host');
    loadScript(
        host +
            '/static/frontend/xems/js/activity-stream-mini-main.js?eid=' +
            event_id +
            '&host=' +
            host +
            '&update=' +
            Math.floor(Date.now() / 1000),
        function() {},
    );
})(window, document);
